// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b1d0992f","358":"c7e36581","457":"850f3002","828":"6cc522b3","851":"3f0086ba"}[chunkId] + ".chunk.js";
};